import React from "react"
import Typography from "@mui/material/Typography";
import {metaDataProperty} from "../preview/previewMetaData";
import {usePreviewContext} from "../../context/PreviewContext";

interface Props {
    children?: string,
    propertyName?: string,
    label?: string,
    sx?: any
    metadataId?: string
}

function CCOParagraph(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    if (props.children && props.children.length > 0) {
        // MUI v9 kennt weder das `paragraph`-Prop (setzte `marginBottom: 16px`, das Element ist
        // über die Variante `body1` weiterhin ein <p>) noch System-Props an der Typography.
        // Beides muss deshalb über `sx` laufen; `props.sx` steht hinten, damit Aufrufer wie
        // zuvor überschreiben können.
        return <Typography {...metaDataProperty(isPreview, props.propertyName,
                                                props.metadataId)}
                           sx={{marginBottom: '16px', ...props.sx}}>{props.label} {props.children}</Typography>
    } else return <></>
}

export default CCOParagraph